export default __webpack_public_path__ + "static/media/powerful_thumbnail.62910b13.jpg";